var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9717 5.71503C14.9227 7.33727 14.1208 8.67896 12.863 8.9994C11.228 9.41594 9.44193 8.00525 8.86145 5.71503H14.9717Z",
    stroke: "#00E194",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6916 2.04968C14.1728 2.55525 14.5789 3.33708 14.7972 4.19448C15.3699 6.44138 14.4994 8.58704 12.8578 9.00548C11.2164 9.42374 9.42728 7.96362 8.85472 5.71672C8.6362 4.85941 8.61673 3.97109 8.79709 3.29709L13.6916 2.04968Z",
    stroke: "#00E194",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8229 8.99158L13.7548 12.6485",
    stroke: "#00E194",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5066 12.394L12.973 12.7849",
    stroke: "#00E194",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00171 4.66534C1.05066 6.28759 1.85262 7.62928 3.11044 7.94972C4.74537 8.36626 6.53156 6.95557 7.11203 4.66534H1.00171Z",
    stroke: "#00E194",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.28177 1C1.80054 1.50557 1.3945 2.28739 1.17607 3.1448C0.603415 5.3917 1.47399 7.53736 3.11551 7.9558C4.75693 8.37405 6.54608 6.91394 7.11863 4.66703C7.33716 3.80973 7.35663 2.9214 7.17627 2.24741L2.28177 1Z",
    stroke: "#00E194",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15034 7.94189L2.21851 11.5988",
    stroke: "#00E194",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4668 11.3444L3.00039 11.7352",
    stroke: "#00E194",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC15);
export default __webpack_public_path__ + "static/media/c15.dffad62baeb2307bbfa4073ef07b729d.svg";
export { ForwardRef as ReactComponent };